export interface KanbanViewHeaderI {
    title: string;
    position: number;
    duration: string;
    dropOff: string;
    dropOffHour: string;
}

export interface KanbanViewCardI {
    select: boolean;
    id: string;
    productName: string;
    productNo: string;
    supplier: string;
    inHouseId: string;
    productType: string;
    image: string;
    dateCreated: string;
}

export interface KanbanViewListI {
    id: string;                     
    header: KanbanViewHeaderI,
    cards: KanbanViewCardI[]; 
}
